import { useState } from "react";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { inputCls } from "../constants";
import { Field } from "./JobOverview";

export const LISTING_STATUSES = [["coming_soon", "Coming soon"], ["active", "Active"], ["pending", "Pending"], ["sold", "Sold"], ["off_market", "Off market"]];
const EMPTY = { headline: "", beds: "", baths: "", sqft: "", lot_size: "", year_built: "", list_price: "", status: "coming_soon", description: "",
  mls_number: "", agent_name: "", agent_brokerage: "", agent_phone: "", agent_email: "", co_agent_name: "", property_type: "" };

export function JobProperty({ job, onChanged }) {
  const [p, setP] = useState({ ...EMPTY, ...(job.property || {}) });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setP({ ...p, [k]: e.target.value });
  const save = async () => {
    setSaving(true);
    try { await api.patch(`/admin/jobs/${job.id}`, { property: p }); toast.success("Property details saved"); onChanged(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  const txt = (k, label, tid) => <Field label={label}><Input data-testid={tid || `prop-${k}`} value={p[k]} onChange={set(k)} className={inputCls} /></Field>;

  return (
    <div className="space-y-8 max-w-4xl">
      <p className="text-sm text-slate-500">These details power the client dashboard today and the property website for each listing in the future.</p>
      <div className="space-y-4">
        {txt("headline", "Listing headline")}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {txt("beds", "Beds")}{txt("baths", "Baths")}{txt("sqft", "Interior sq.ft")}{txt("lot_size", "Lot size")}
          {txt("year_built", "Year built")}{txt("list_price", "List price")}{txt("property_type", "Property type")}
          <Field label="Listing status">
            <Select value={p.status} onValueChange={(v) => setP({ ...p, status: v })}><SelectTrigger data-testid="prop-status" className={inputCls}><SelectValue /></SelectTrigger>
              <SelectContent>{LISTING_STATUSES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent></Select>
          </Field>
        </div>
        <Field label="Description"><Textarea data-testid="prop-description" value={p.description} onChange={set("description")} rows={5} className={inputCls} /></Field>
      </div>
      <div className="space-y-4">
        <h3 className="font-serif-display text-xl text-[#101828]">Listing agent</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {txt("mls_number", "MLS #")}{txt("agent_name", "Agent name")}{txt("agent_brokerage", "Brokerage")}
          {txt("agent_phone", "Agent phone")}{txt("agent_email", "Agent email")}{txt("co_agent_name", "Co-listing agent")}
        </div>
      </div>
      <Button data-testid="prop-save" disabled={saving} onClick={save} className="rounded-xl bg-[#0C2347] hover:bg-[#123262] text-white px-8">{saving ? "Saving…" : "Save property details"}</Button>
    </div>
  );
}
